<template>
  <div class="header-player" v-show="$root.deviceAudioSrc">
    <div class="left-item">
      <img
      :src="'http://classicalwalkoffame.org/inductees/' + inductee.ImageURL">
    </div>
    
    <div class="middle-item">
      <a href="#/device">
        <span class="name">{{ inductee.InducteeName }}</span><br>
        <span class="song">{{ inductee.MusicTitle }}</span><br>
      </a>
    </div>
    
    <div class="right-item">
      <sprite-button class="homeButton"
      @click="$root.togglePauseOnDevice()"
      :background-url="buttonImg"
      width="56px"
      height="50px"
      >Play</sprite-button>
      <sprite-button
      @click="$root.stopOnDevice()"
      background-url="img/stop_button.png"
      width="56px"
      height="50px"
      >Stop</sprite-button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    buttonImg () {
      return this.$root.deviceAudioPaused ? 'img/play_button.png' : 'img/pause_button.png'
    },
    inductee () {
      return this.$root.nowPlaying('device')
    }
  },
}
</script>

<style lang="less">
.header-player {
  background: none;
  display: flex;
  flex-direction: row;
  
  .left-item {
    img {
      width: 40px;
      height: 40px;
      margin: 5px;
    }
  }
  .middle-item {
    flex: 1;
    padding: 5px;
  }
  .name {
    color: #fff;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: bold;
    font-size: 16px;
  }
  .song {
    color: #afd2ef;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: normal;
    font-style: italic;
    font-size: 15px;
  }
  .right-item {
    .sprite-button {
      display: inline-block;
      margin-left: -10px;
    }
  }
}
</style>